import React, {createElement, useRef, useState} from 'react'
import moduleCss from './index.module.scss'
import { Swiper } from 'swiper/esm/react/swiper.js'
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss'
import md5 from 'md5';
import TextInfo_skin0 from "./TextInfo_skin0";
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng-fe/lowcode_tool/src/method/common'
import { formatImage } from '@ifeng-fe/public_method'
import Chip from 'Chip';
import {parseToCssCode} from "./utils";

SwiperCore.use([ Navigation, Pagination, Autoplay ])

export interface Swiper_1_Props {
    nodeId?: string
    style?: object,
    swiperChip: TYPE_Chip
    height?: number // 轮播图高度
    loop: boolean // 是否循环

    // nav
    isHasNav: boolean // 是否有nav
    leftNavImage?: string // 左侧nav的图片
    leftNavHoverImage?: string // 左侧nav hover 时的图片
    rightNavImage?: string // 右侧nav的图片
    rightNavHoverImage?: string // 右侧nav hover的图片
    navWidth?: string
    navHeight?: string
    navY?: number
    navX?: number

    // 自动播放
    isAutoPlay: boolean // 是否开启自动播放
    autoSpeed: number // 自动播放的速度

    // 标题
    isHasTitle: boolean // 是否显示文本
    titleHeight: number // 文本高度
    titleStyle?: object // 文本样式

    // 分页器
    isHasPagination: boolean // 是否有分页器
    paginationPosition: string // 分页器位置，位于标题内部还是轮播图下方
    paginationNormalStyle?: object // 分页器单条普通样式
    paginationActiveStyle?: object // 分页器单条激活样式
    paginationTotalStyle?: object // 分页器整体样式

    skin: number
    __designMode: string
}

const Swiper_1: React.FC<Swiper_1_Props> = (props) => {
    let {
        nodeId, swiperChip, style, height, loop,
        isHasNav, leftNavImage, leftNavHoverImage, rightNavImage, rightNavHoverImage, navWidth, navHeight, navY, navX,
        isAutoPlay, autoSpeed, skin, __designMode,
        isHasTitle, titleHeight, titleStyle,
        isHasPagination, paginationPosition, paginationNormalStyle, paginationActiveStyle, paginationTotalStyle
    } = props

    const [ swiperIndex, setSwiperIndex ] = useState(0) // swiper 内部的 index
    const [ isHoverLeft, setIsHoverLeft ] = useState(false)
    const [ isHoverRight, setIsHoverRight ] = useState(false)

    const paginationRef = useRef()

    const swiperChipData = useChip(swiperChip)
    const swiperChipComponentData = formatChip(swiperChip)

    const GetPaginationNormalCSS = () => (parseToCssCode(paginationNormalStyle).trim().replace(/^#main \{/g, '').replace(/}$/g, '').trim())
    const GetPaginationActiveCSS = () => (parseToCssCode({ ...paginationNormalStyle, ...paginationActiveStyle }).trim().replace(/^#main \{/g, '').replace(/}$/g, '').trim())

    const getKey = () => {
        return md5(JSON.stringify({ isAutoPlay, autoSpeed, paginationNormalStyle, paginationActiveStyle, paginationTotalStyle, paginationPosition }));
    };

    const GetTextInfo = () => {
        switch (skin) {
            case 0: {
                return <TextInfo_skin0 swiperIndex={swiperIndex} title={swiperChipData[swiperIndex]?.title} summary={swiperChipData[swiperIndex]?.summary} />
            }
            default: return null
        }
    }

    return (
        <Chip {...swiperChipComponentData}>
            <div id={nodeId} style={{ position: 'relative' }}>
                <div className={moduleCss.swiperWp} style={{ ...style }}>
                    {
                        Array.isArray(swiperChipData) && swiperChipData.length > 0 &&
                        <Swiper
                            key={getKey()}
                            simulateTouch={__designMode !== 'design'}
                            initialSlide={0}
                            loop={loop}
                            autoplay={isAutoPlay ? { delay: autoSpeed, disableOnInteraction: false } : false }
                            navigation={isHasNav ? { prevEl: `.${moduleCss.prev}`, nextEl: `.${moduleCss.next}` } : false}
                            pagination={
                                isHasPagination
                                    ?
                                    {
                                        el: paginationRef.current,
                                        type: 'custom',
                                        renderCustom: function (swiper, current, total) {
                                            let res = `<div class="${moduleCss.dotWp}">`

                                            for(let i=1; i<=total; i++) {
                                                res += `<div style="${i === current ? GetPaginationActiveCSS() : GetPaginationNormalCSS()}"></div>`
                                            }

                                            res += `</div>`

                                            return res
                                        }
                                    }
                                    : false
                            }
                            onSlideChange={(swiper) => {
                                setSwiperIndex(swiper.realIndex)
                            }}
                            style={{ height }}
                        >
                            {
                                swiperChipData && swiperChipData.map((item, index) => {
                                    return (
                                        <SwiperSlide key={index}>
                                            <div className={moduleCss.swiperItem}>
                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                    <img src={formatImage(getThumbnailFromRecommend(item), undefined, height)} alt={item.name} />
                                                </a>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })
                            }
                        </Swiper>
                    }
                    {
                        isHasNav &&
                        <React.Fragment>
                            <img style={{ width: `${navWidth}px`, height: `${navHeight}px`, top: `${navY}px`, left: `${navX}px` }} className={moduleCss.prev} src={isHoverLeft ? leftNavHoverImage || leftNavImage : leftNavImage} alt="" onMouseEnter={() => setIsHoverLeft(true)} onMouseLeave={() => setIsHoverLeft(false)} />
                            <img style={{ width: `${navWidth}px`, height: `${navHeight}px`, top: `${navY}px`, right: `${navX}px` }} className={moduleCss.next} src={isHoverRight ? rightNavHoverImage || rightNavImage : rightNavImage} alt="" onMouseEnter={() => setIsHoverRight(true)} onMouseLeave={() => setIsHoverRight(false)} />
                        </React.Fragment>
                    }
                    {
                        isHasTitle
                        ?
                            (
                                [0].includes(skin)
                                    ?
                                        <div style={{ position: 'relative' }}>
                                            {GetTextInfo()}
                                            {
                                                isHasPagination && paginationPosition.indexOf('title') === 0 && <div ref={paginationRef} className={`${moduleCss.pagination} ${moduleCss[paginationPosition]}`} style={paginationTotalStyle} />
                                            }
                                        </div>
                                    :
                                        <div className={moduleCss.textPart} style={{ height: `${titleHeight}px`, ...titleStyle }}>
                                            <div style={{ flex: '1' }}>
                                                {swiperChipData[swiperIndex]?.title}
                                            </div>
                                            {
                                                isHasPagination && paginationPosition.indexOf('title') === 0 && <div ref={paginationRef} className={`${moduleCss.pagination} ${moduleCss[paginationPosition]}`} style={paginationTotalStyle} />
                                            }
                                        </div>
                            )
                            : null
                    }
                </div>
                <Mask visible={!swiperChip.id} zIndex={3}>
                    示例推荐位碎片—{swiperChip.default.id}
                </Mask>
                {
                    isHasPagination && paginationPosition.indexOf('swiper') === 0 &&
                    <div ref={paginationRef} className={`${moduleCss.pagination} ${moduleCss[paginationPosition]}`} style={paginationTotalStyle} />
                }
            </div>
        </Chip>
    )
}

Swiper_1.displayName = '轮播图_1'

export default Swiper_1;
